<!--
 * @version: V1.0.0
 * @Date: 2023-05-10 15:04:01
 * @LastEditors: lzq
 * @LastEditTime: 2023-05-11 14:48:15
 * @company: 睿展数据
 * @FilePath: \udi-web\src\components\customTooltips\index.vue
 * @Descripttion:
-->
<template>
  <div class="tooltip-container">
    <el-tooltip placement="top-start" class="my-tooltip" :disabled="showTooltip" :content="text">
      <p ref="tooltipBox" class="text-box">
        <span ref="tooltipItem" class="">{{ text }}</span>
      </p>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'myTooltip',
  props: {
    text: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      showTooltip: true
    }
  },
  watch: {
    text: {
      handler() {
        this.$nextTick(() => this.checkWidth())
      },
      immediate: true
    }
  },
  methods: {
    checkWidth() {
      const boxWidth = this.$refs.tooltipBox.offsetWidth
      const itemWidth = this.$refs.tooltipItem.offsetWidth
      this.showTooltip = boxWidth > itemWidth
    }
  }
}
</script>
<style scoped lang="less">
.tooltip-container {
  max-width: 70%;
  margin-right: 8px;
  .text-box {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
